import React, { useState, useCallback, useEffect } from 'react'
import {
  LegacyCard,
  Page,
  Layout,
  Button,
  DataTable,
  Icon,
  ButtonGroup,
  EmptyState,
  Box,
  Badge,
  Tabs,
} from '@shopify/polaris'
import styles from 'Styles/BookingDetails.scss'
import Loader from 'Components/Loader'
import { useDispatch, useSelector } from 'react-redux'
import moment from 'moment'
import BookingActions from 'Redux/BookingRedux'
import { useParams, useHistory } from 'react-router-dom'
import ManualSubscriptionBookingModal from 'Components/CustomFlow/ManualSubscriptionBookingModal'
import CancelSubscription from 'Components/CustomFlow/CancelSubscription'
import EditCustomerPaymentModal from 'Components/CustomFlow/EditCustomerPaymentModal'
import { DeleteIcon, EditIcon } from '@shopify/polaris-icons'
import OrderSchedule from '../../Components/CustomFlow/OrderSchedule'

const headings = ['Team Member', 'Service Name', 'Service Time']
const billingHistoryHeading = ['Name', 'Billing Date', 'Status']
let tabsList = [
  {
    id: 'booking-details',
    content: 'Booking Details',
    panelID: 'booking-details',
  },
]
const allTabs = [
  {
    id: 'booking-details',
    content: 'Booking Details',
    panelID: 'booking-details',
  },
  {
    id: 'billing-history',
    content: 'Billing History',
    panelID: 'billing-history',
  },
]

function CustomerSubscriptionDetails(props) {
  const dispatch = useDispatch()
  const history = useHistory()
  const params = useParams()
  const [subscription, setSubscription] = useState({})
  let detailsFetching = useSelector((state) => state.booking.detailFetching)
  let subscriptionData = useSelector((state) => state.booking.detailData)
  const [bookings, setBookings] = useState([])
  const [showModal, setShowModal] = useState(false)
  let metadata = subscriptionData.metadata
  const settingsData = useSelector((state) => state.settings.data)
  const [showCancelModal, setShowCancelModal] = useState(false)
  const [showPaymentModal, setShowPaymentModal] = useState(false)
  const [showOrderSchedule, setShowOrderSchedule] = useState(false)
  const [schedule, setSchedule] = useState([])
  const [billingHistoryRows, setBillingHistoryRows] = useState(['', '', '', ''])
  const [selectedTab, setSelectedTab] = useState(tabsList[0].id)
  const handleTabChange = useCallback(
    (selectedTabId) => setSelectedTab(selectedTabId),
    []
  )
  const [tabs, setTabs] = useState(tabsList)

  useEffect(() => {
    if (subscriptionData.id) {
      setSubscription(subscriptionData)

      if (subscriptionData.subscription_type === 'recurring') {
        setTabs(allTabs)
        setSelectedTab(allTabs[0].id)
      } else {
        setTabs(tabsList)
        setSelectedTab(tabsList[0].id)
      }

      let bks = renderBookingsView(
        !!subscriptionData && subscriptionData.bookings
          ? subscriptionData.bookings
          : []
      )
      setBookings(bks)

      console.log('inside useEffect', subscriptionData.sub_billing_histories)
      let billingData = renderBillingHistoryList(
        subscriptionData.sub_billing_histories
      )
      setBillingHistoryRows(billingData)
    }
  }, [subscriptionData])

  useEffect(() => {
    if (params.id) {
      dispatch(BookingActions.bookingsSubscriptionRequest(params.id))
    }
  }, [])

  const editCustomerPayment = () => {
    setShowPaymentModal(true)
  }

  const renderBillingHistoryList = (billingHistoryList) => {
    if (!billingHistoryList || billingHistoryList.length === 0) {
      return []
    }

    return !!billingHistoryList
      ? billingHistoryList.map((o) => {
          let values = []
          billingHistoryHeading.map((h) => {
            let content = ''
            switch (h) {
              case 'Name':
                content = (
                  <p className="exclude-translation notranslate">
                    {o.order_name}
                  </p>
                )
                break
              case 'Billing Date':
                content = (
                  <p className="exclude-translation notranslate">
                    {o.billing_date
                      ? moment(o.billing_date).format('MMM D YYYY, h:mm:ss a')
                      : '-'}
                  </p>
                )
                break
              case 'Status':
                content = (
                  <div
                    className={styles.justify_center}
                    style={{
                      flexDirection: 'column',
                    }}
                  >
                    {o.processing ? (
                      <p className="exclude-translation notranslate">
                        <Badge tone="info">Processing</Badge>
                      </p>
                    ) : (
                      <>
                        <p className="exclude-translation notranslate">
                          {o.paid ? (
                            <Badge tone="success">Success</Badge>
                          ) : (
                            <>
                              {o.skipped ? (
                                <Badge tone="attention">Skipped</Badge>
                              ) : (
                                <Badge tone="critical">Failed</Badge>
                              )}
                            </>
                          )}
                        </p>
                        {o.skipped ? (
                          <></>
                        ) : (
                          <>
                            {!o.paid && (
                              <p className="exclude-translation notranslate">
                                Status: Failed with error message
                                {o.error_message}
                              </p>
                            )}
                          </>
                        )}
                      </>
                    )}
                  </div>
                )
                break
              default:
                break
            }
            values.push(content)
          })
          return values
        })
      : [[]]
  }

  const renderBookingsView = (bookingsList) => {
    return bookingsList.map((o) => {
      let values = []
      headings.map((h) => {
        let content = ''
        switch (h) {
          case 'Team Member':
            content = (
              <p className="exclude-translation notranslate">
                {o.team_member ? o.team_member.name : 'Admin'}
              </p>
            )
            break

          case 'Service Name':
            content = (
              <div className="exclude-translation notranslate">
                <p>{o.product_name}</p>
                {o.variant_name && (
                  <p style={{ fontSize: '0.8em', color: 'gray' }}>
                    {o.variant_name}
                  </p>
                )}
              </div>
            )
            break
          case 'Service Time':
            content =
              o.scenario === 'multi_day' ? (
                <div className="exclude-translation">
                  <p>{`${moment(o.start_date).format('MMM Do YYYY')} - ${moment(
                    o.end_date
                  ).format('MMM Do YYYY')}`}</p>
                  <p style={{ fontSize: '0.8em', color: 'gray' }}>
                    Number of days: {o.quantity} days
                  </p>
                </div>
              ) : (
                <div className="exclude-translation">
                  <p>{moment(o.selected_time).format('llll')}</p>
                  <p style={{ fontSize: '0.8em', color: 'gray' }}>
                    Duration: {o.duration} mins
                  </p>
                </div>
              )
            break

          default:
            break
        }
        values.push(content)
      })
      return values
    })
  }

  const bookManual = () => {
    setShowModal(true)
  }

  const closeSubscription = () => {
    history.push('/apps/customer_portal/subscription_bookings')
  }

  const deleteSubscription = () => {
    setShowCancelModal(true)
  }

  const cancelSubscription = () => {
    dispatch(
      BookingActions.bookingsSubscriptionCancelRequest(params.id, () => {
        closeSubscription()
        dispatch(BookingActions.bookingsSubscriptionsListRequest())
      })
    )
  }

  const orderSchedule = () => {
    setSchedule(subscriptionData.schedule)
    setShowOrderSchedule(true)
  }

  return (
    <>
      {detailsFetching ? (
        <Loader />
      ) : (
        <>
          <Page
            fullWidth
            backAction={{
              content: 'Subscription',
              onAction: closeSubscription,
            }}
            title={subscriptionData.order_name}
            primaryAction={
              subscriptionData.status === 'ACTIVE' &&
              subscriptionData.max_booking_count -
                subscriptionData.curr_booking_count >
                0 && (
                <Button onClick={bookManual} variant="primary">
                  Book Remaining Slots
                </Button>
              )
            }
            secondaryActions={
              subscriptionData.status === 'ACTIVE'
                ? [
                    {
                      content: 'Delete Subscription',
                      onAction: deleteSubscription,
                    },
                  ]
                : []
            }
          >
            <Layout>
              <Layout.Section>
                <LegacyCard title="Subscription Details">
                  <LegacyCard.Section title="Service Name">
                    <p>
                      {!!metadata && metadata.lines && metadata.lines.length > 0
                        ? `${metadata.lines[0].title} - ${
                            metadata.lines[0].variantTitle || ''
                          }`
                        : ''}
                    </p>
                  </LegacyCard.Section>
                  <LegacyCard.Section title="Frequency">
                    <p>
                      {!!metadata &&
                      metadata.billingPolicy &&
                      metadata.billingPolicy.intervalCount
                        ? `Every ${metadata.billingPolicy.intervalCount} ${metadata.billingPolicy.interval}`
                        : 'Fixed'}
                    </p>
                  </LegacyCard.Section>
                  <LegacyCard.Section title="Booking Count">
                    <p>
                      <span style={{ display: 'flex' }}>
                        {subscriptionData.curr_booking_count}/
                        {subscriptionData.max_booking_count}{' '}
                      </span>
                    </p>
                  </LegacyCard.Section>
                  <LegacyCard.Section title="Next Billing On">
                    <p>
                      {!!subscriptionData && !!subscriptionData.next_billing_date
                        ? moment(subscriptionData.next_billing_date).format(
                            'LLL'
                          )
                        : '-'}
                    </p>
                  </LegacyCard.Section>
                  {subscriptionData?.subscription_type === 'fixed' && (
                    <LegacyCard.Section title="Expires on">
                      <p>
                        {!!subscriptionData &&
                        !!subscriptionData.expiration_date
                          ? moment(subscriptionData.expiration_date).format(
                              'DD MMM YYYY'
                            )
                          : 'Never'}
                      </p>
                    </LegacyCard.Section>
                  )}
                  <LegacyCard.Section title="Status">
                    <p
                      style={{
                        color: subscriptionData.archived
                          ? 'black'
                          : subscriptionData.status === 'ACTIVE'
                          ? 'green'
                          : 'red',
                      }}
                    >
                      {subscriptionData.archived ? (
                        'ARCHIVED'
                      ) : subscriptionData.status !== 'PAYMENT_DUE' ? (
                        subscriptionData.status
                      ) : (
                        <span>
                          {subscriptionData.status}{' '}
                          {/* <span style={{ marginLeft: 6 }}>
                            <Button onClick={retryPayment} variant="tertiary">
                              Retry Payment
                            </Button>
                          </span> */}
                        </span>
                      )}
                    </p>
                  </LegacyCard.Section>
                </LegacyCard>
              </Layout.Section>
              <Layout.Section variant="oneThird">
                <LegacyCard title="Customer Details">
                  <LegacyCard.Section title="Customer Name">
                    <p>
                      {!!metadata && metadata.customer
                        ? `${metadata.customer.firstName} - ${metadata.customer.lastName}`
                        : ''}
                    </p>
                  </LegacyCard.Section>
                  <LegacyCard.Section title="Customer Email">
                    {!!metadata && metadata.customer
                      ? `${metadata.customer.email}`
                      : ''}
                  </LegacyCard.Section>
                  <LegacyCard.Section title="Payment Method">
                    <p>
                      {!!metadata &&
                      metadata.customerPaymentMethod &&
                      metadata.customerPaymentMethod.instrument ? (
                        <span style={{ display: 'flex' }}>
                          {
                            metadata.customerPaymentMethod.instrument
                              .maskedNumber
                          }
                          <div
                            style={{
                              display: 'flex',
                              width: 14,
                              marginLeft: 10,
                              cursor: 'pointer',
                            }}
                            onClick={editCustomerPayment}
                          >
                            <Icon source={EditIcon} color="gray" />
                          </div>
                        </span>
                      ) : (
                        ''
                      )}
                    </p>
                  </LegacyCard.Section>
                </LegacyCard>
              </Layout.Section>
            </Layout>
            <Box padding="400"></Box>
            <Layout>
              <Layout.Section>
                <LegacyCard>
                  <Tabs
                    tabs={tabs}
                    selected={tabs.findIndex((tab) => tab.id === selectedTab)}
                    onSelect={(selectedTabIndex) =>
                      handleTabChange(tabs[selectedTabIndex].id)
                    }
                  >
                    {selectedTab === 'billing-history' && (
                      <>
                        {billingHistoryRows.length === 0 ? (
                          <EmptyState
                            heading="No Billing History Found"
                            image="https://cdn.shopify.com/s/files/1/0262/4071/2726/files/emptystate-files.png"
                          >
                            <p>This subscription has not been charged yet</p>
                          </EmptyState>
                        ) : (
                          <DataTable
                            columnContentTypes={[
                              'text',
                              'text',
                              'text',
                              'text',
                            ]}
                            headings={billingHistoryHeading}
                            rows={
                              Array.isArray(billingHistoryRows) &&
                              Array.isArray(billingHistoryRows[0])
                                ? billingHistoryRows
                                : [[]]
                            }
                            stickyHeader
                          />
                        )}
                      </>
                    )}
                    {selectedTab === 'booking-details' && (
                      <>
                        {bookings.length == 0 ? (
                          <EmptyState
                            heading={
                              'No Bookings linked to this Subscription yet'
                            }
                          ></EmptyState>
                        ) : (
                          <DataTable
                            columnContentTypes={[
                              'text',
                              'text',
                              'text',
                              'numeric',
                            ]}
                            headings={headings}
                            rows={bookings}
                          />
                        )}
                      </>
                    )}
                  </Tabs>
                </LegacyCard>
              </Layout.Section>
            </Layout>
          </Page>
          <ManualSubscriptionBookingModal
            showModal={showModal}
            setShowModal={setShowModal}
            title="Book Time"
            connectedVariants={
              subscription && subscription.appointments
                ? subscription.appointments
                : []
            }
            shop={settingsData}
            id={subscription && subscription.id ? subscription.id : ''}
            closeSubscription={closeSubscription}
            customerPortal
          />
          <CancelSubscription
            showModal={showCancelModal}
            setShowModal={setShowCancelModal}
            cancelSubscription={cancelSubscription}
            handleClose={() => {
              setShowCancelModal(false)
            }}
          />
          <EditCustomerPaymentModal
            showModal={showPaymentModal}
            setShowModal={setShowPaymentModal}
            handleClose={() => {
              setShowPaymentModal(false)
            }}
            uuid={subscriptionData.id}
          />

          <OrderSchedule
            showModal={showOrderSchedule}
            setShowModal={setShowOrderSchedule}
            schedule={schedule}
          />
        </>
      )}
    </>
  )
}

export default CustomerSubscriptionDetails
